/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusDropdownMiniDto } from '../../models/lexplus-dropdown-mini-dto';

export interface ErlassControllerSearchV1$Params {
  search?: string;

/**
 * Comma-separated erlassIDs; replaces the search.
 */
  ids?: string;
  limit?: number;
}

export function erlassControllerSearchV1(http: HttpClient, rootUrl: string, params?: ErlassControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusDropdownMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, erlassControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('ids', params.ids, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusDropdownMiniDto>>;
    })
  );
}

erlassControllerSearchV1.PATH = '/v1/erlass/search';
